import React from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const CampaignCategoryTableItem = ({
  category,
  handleEdit,
  handleDelete,
  handleUpdateStatus,
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const toggleStatus = () => {
    const newStatus = category.is_active === 1 ? 0 : 1;
    handleUpdateStatus(category.id, newStatus);
  };

  return (
    <tr>
      <td className="category_id">
        <span className="fw-semibold">{category.id}</span>
      </td>
      <td className="name">
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <h5 className="fs-14 mb-0">{category.name}</h5>
          </div>
        </div>
      </td>
      <td className="arabic_name">
        <div className="text-end" dir="rtl">
          <h5 className="fs-14 mb-0">{category.arabic_name}</h5>
        </div>
      </td>
      <td className="icon">
        {category.icon ? (
          category.icon.startsWith("http") || category.icon.includes(".") ? (
            <img
              src={category.icon}
              alt="Category icon"
              style={{ width: "30px", height: "30px", objectFit: "contain" }}
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "inline";
              }}
            />
          ) : (
            <i className={`${category.icon} fs-3`}></i>
          )
        ) : (
          <span className="text-muted">-</span>
        )}
        <span className="text-muted" style={{ display: "none" }}>
          Invalid
        </span>
      </td>
      <td className="campaigns_count">
        <span className="badge badge-soft-info">
          {category.campaigns_count || 0} campaigns
        </span>
      </td>
      <td className="status">
        <span
          className={`badge badge-soft-${
            category.is_active === 1 ? "success" : "danger"
          } text-uppercase`}
        >
          {category.is_active === 1 ? "Active" : "Inactive"}
        </span>
      </td>
      <td className="created_at">
        <span className="text-muted">{formatDate(category.created_at)}</span>
      </td>
      <td>
        <UncontrolledDropdown>
          <DropdownToggle
            href="#"
            className="btn btn-soft-secondary btn-sm"
            tag="button"
          >
            <i className="ri-more-fill align-middle"></i>
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem onClick={() => handleEdit(category)}>
              <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
              Edit
            </DropdownItem>
            <DropdownItem onClick={toggleStatus}>
              <i
                className={`ri-${
                  category.is_active === 1 ? "close" : "check"
                }-circle-fill align-bottom me-2 text-muted`}
              ></i>
              {category.is_active === 1 ? "Deactivate" : "Activate"}
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem
              onClick={() => handleDelete(category.id)}
              className="text-danger"
            >
              <i className="ri-delete-bin-fill align-bottom me-2"></i>
              Delete
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </td>
    </tr>
  );
};

export default CampaignCategoryTableItem;
